import React, { Component } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import NotFound from "../../Pages/NotFound/NotFound";
import { NavLink, Routes, Route } from "react-router-dom";
import Home from "../../Pages/Home/Home";
import About from "../../Pages/About/About";
import Services from "../../Pages/Services/Services";
import Careers from "../../Pages/Careers/Careers";
import CareerDetails from "../../Pages/CareerDetails/CareerDetails";
import Portfolio from "../../Pages/Portfolio/Portfolio";
import ProjectView from "../../Pages/ProjectView/ProjectView";
import ContactUs from "../../Pages/ContactUs/contactUs";
import SoftwareAndMobile from "../../Pages/Services/Sub-Services/Software&Mobile/softwareAndMobile";
import SubServices from "../../Pages/Services/Sub-Services/SubServices/subServices";
import SubProject from "../../Pages/ProjectView/subProject";
import ThankYouContactUs from "../../Pages/ThankYou-ContactUS/ThankYouContactUs";
import ThankYouCareers from "../../Pages/ThankYou-Careers/ThankYouCareers";
import Terms from "../../Pages/TermsAndCondition/terms";
import Privacy from "../../Pages/PrivacyPolicy/privacy";
import './NavBar.css';

export default class NavBar extends Component {

  state = {
    expanded: false,
  };

  handleClose = () => {
    this.setState({ expanded: false });
  };
  render() {
    return (
      <>
        <Navbar expand="lg" expanded={this.state.expanded}
          onToggle={(expanded) => this.setState({ expanded })} className="nav-bar px-md-4  p-md-4 px-4  py-1">
          <Navbar.Brand as={NavLink} to="/" className="fw-bold"  >
            <img src="./assets/images/ambrum-logo.png" alt="" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar-nav" />
          <Navbar.Collapse id="main-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={NavLink} to="/" className="mx-md-3" end onClick={this.handleClose}>
                Home
              </Nav.Link>
              <Nav.Link as={NavLink} to="/about" className="mx-md-3" end onClick={this.handleClose}>
                About
              </Nav.Link>
              <Nav.Link as={NavLink} to="/services" className="mx-md-3" end onClick={this.handleClose}>
                Services
              </Nav.Link>
              <Nav.Link as={NavLink} to="/portfolio" className="mx-md-3" end onClick={this.handleClose}>
                Portfolio
              </Nav.Link>
              <Nav.Link as={NavLink} to="/careers" className="mx-md-3" end onClick={this.handleClose}>
                Careers
              </Nav.Link>
              {/* <Nav.Link as={NavLink} to="/blog" end>
                  Blog
                </Nav.Link> */}
              <Nav.Link as={NavLink} to="/talk-to-Us " end className="ttu-button px-3 " onClick={this.handleClose}>

                Let’s Talk
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/software-mobile" element={<SoftwareAndMobile />} />
            <Route path="/services/sub-services" element={<SubServices />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/career-details" element={<CareerDetails />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/project-view" element={<ProjectView />} />
            <Route path="/project-view/sub-project" element={<SubProject />} />
            <Route path="/talk-to-us" element={<ContactUs />} />
            <Route path="/thankyou" element={<ThankYouContactUs />} />
            <Route path="/application-success" element={<ThankYouCareers />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </>
    );
  }
}
